import React, { useState, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';
import { Topic, Answer, MultipleChoiceWrapper } from '../../../../services/types/Toolkit';
import OperationContext from '../context';
import TopicsNavs from './TopicsNavs';
import MainContext from '../../../App/MainProvider/context';
import Role from '../../../../types/role';

interface Props {
  topics: Topic[];
  title: string;
  toolkitAnswers: Answer[];
  isDraft: boolean;
  isEspf: boolean;
  isSubmitting: boolean;
  isGettingImpact: boolean;
  handleSubmit: (e: React.FormEvent) => void;
  handleInputChange: (
    value: number,
    questionId: number,
    topicId: number,
    multipleChoiceId: MultipleChoiceWrapper | null
  ) => void;
  handleFinishButtonClick: () => void;
}

const Topics = (props: Props) => {
  const {
    topics,
    title,
    toolkitAnswers,
    isDraft,
    isEspf,
    isSubmitting,
    isGettingImpact,
    handleSubmit,
    handleInputChange,
    handleFinishButtonClick,
  } = props;
  const { t } = useTranslation();
  const [toolkitCompleted, setToolkitCompleted] = useState(false);
  const [visibleTopic, setVisibleTopic] = useState(1);
  const { operation } = useContext(OperationContext);
  const { user, inSuperUserMode } = useContext(MainContext);

  const isToolkitCompleted = (completed: boolean) => {
    setToolkitCompleted(completed);
  };

  const refSection = useRef<HTMLDivElement>(null);
  const getTopicTitle = (topicNumber: number) => {
    const topic = topics.find((x) => x.number === topicNumber);
    if (!topic) {
      return '';
    }

    const sufix = isEspf ? t('sufixQuestions') : '';

    if (topics.length === 1) {
      return `${topic.description} ${sufix}`;
    }

    const topicStr = topic.number < 10 ? `0${topic.number}` : topic.number.toString();
    return `${topicStr}. ${topic.description} ${sufix}`;
  };

  const handleTopicTabChange = (topicNumber: number) => {
    setVisibleTopic(topicNumber);
    if (document.getElementsByClassName('toolkit-questions')[0] != null) {
      document
        .getElementsByClassName('toolkit-questions')[0]
        .scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div style={{ overflowX: 'auto' }}>
      <div style={{ minWidth: '1065px' }} ref={refSection}>
        <form onSubmit={handleSubmit}>
          <div className="toolkit-headers">
            <div className="topics-header">
              <div className="w-100">{title}</div>
              <div>Status</div>
            </div>
            <div className="questions-header">
              <div>{getTopicTitle(visibleTopic)}</div>
            </div>
          </div>
          <div className="topics-panel">
            <div className="tabs tabs--vertical">
              <div className="tabs__wrap">
                <TopicsNavs
                  answers={toolkitAnswers}
                  topics={topics}
                  handleInputChange={handleInputChange}
                  toolkitCompleted={isToolkitCompleted}
                  isDraft={isDraft}
                  isEspf={isEspf}
                  handleTabChange={handleTopicTabChange}
                />
              </div>
            </div>
          </div>
          {isDraft &&
            (operation.isMember ||
              inSuperUserMode() ||
              (isEspf && user.roleCode === Role.HSO) ||
              (isEspf && operation.belongsGS && user.isGuidanceService) ||
              operation.userTaskDelegations.includes('TOOLKIT')) && (
              <div className="toolkit__footer">
                <Button
                  type="submit"
                  color="secondary"
                  disabled={isSubmitting}
                  itemID="btn_saveChanges"
                >
                  {t('saveChanges')}
                </Button>{' '}
                <Button
                  type="button"
                  color="primary"
                  disabled={!toolkitCompleted || isGettingImpact}
                  onClick={handleFinishButtonClick}
                  itemID="btn_finishPdf"
                >
                  {isEspf ? t('finishSF') : t('finishPdf')}
                </Button>
              </div>
            )}
        </form>
      </div>
    </div>
  );
};

export default Topics;
